import React from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";

import { useControlBarBulkModifyDataAcquisitionTypeButtonHook } from "./use-control-bar-bulk-modify-data-acquisition-type-button-hook";
import { useI18N } from "@src/language/language-context";

export const ControlBarBulkModifyDataAcquisitionTypeButton = () => {
  const { icon, disabled, openDataAcquisitionBulkEditModal } =
    useControlBarBulkModifyDataAcquisitionTypeButtonHook();
  const i18n = useI18N();
  const tooltip = i18n(
    "modules.machineStructurePanelControlBar.dataAcquisition",
  );

  return (
    <IconButton
      key={tooltip}
      tooltip={tooltip}
      tooltipPosition="bottom"
      fun={openDataAcquisitionBulkEditModal}
      icon={icon}
      disabled={disabled}
    />
  );
};
